import { AppMapperError } from 'module/Common';

export namespace LoggerUtils {
  export function logError(error: any): void {
    // dump on DOM
    // const elem = document.getElementById('root');
    // if (elem) {
    //   // Debug Fetch as Google
    //   elem.style.fontSize = '2rem';
    //   elem.style.maxWidth = '300px';
    //   if (error) {
    //     elem.innerHTML =
    //       error.toString() +
    //       '<br />' +
    //       (error.stack ? error.stack.toString() + '<br />' : '') +
    //       (error.subError ? error.subError.toString() + '<br />' : '') +
    //       (error.subError ? error.subError.stack.toString() : '');
    //   } else {
    //     elem.innerHTML = 'Error :' + error;
    //   }
    // }
    // Normal log
    if (error instanceof AppMapperError) {
      const msg = error.message + ' > ' + error.subError.message;
      const group = console.group && console.groupEnd;
      if (group) {
        console.group(msg);
      } else {
        console.info(msg);
      }
      console.error(error);
      console.error(error.subError);
      if (group) {
        console.groupEnd();
      }
      return;
    }
    console.error(error);

    // const errorText = [
    //   error.message,
    //   'URL: ' + error.filename,
    //   'Line: ' + error.lineno + ', Column: ' + error.colno,
    //   'Stack: ' + ((error.error && error.error.stack) || '(no stack trace)'),
    // ].join('\n');
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/LoggerUtils.ts